"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function SurfaceSubtitle(_ref) {
  var subtitle = _ref.subtitle;
  var textVariant = function textVariant(text) {
    return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body2",
      color: "textSecondary"
    }, text));
  };
  var gridVariant = function gridVariant(_ref2) {
    var text = _ref2.text,
      complement = _ref2.complement,
      labels = _ref2.labels;
    return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      container: true,
      justifyContent: "flex-start",
      alignContent: "center",
      alignItems: "center",
      spacing: 1
    }, text && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: "auto"
    }, textVariant(text))), complement && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: "auto"
    }, complement)), labels === null || labels === void 0 ? void 0 : labels.map(function (label, i) {
      var _a, _b;
      return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        key: "".concat(label.text, "-").concat(i),
        item: true,
        xs: "auto"
      }, /*#__PURE__*/_react["default"].createElement(_material.Chip, {
        label: label.text,
        size: "small",
        variant: (_a = label.variant) !== null && _a !== void 0 ? _a : 'outlined',
        color: (_b = label.color) !== null && _b !== void 0 ? _b : 'info'
      }));
    })));
  };
  if (typeof subtitle === 'string') {
    return textVariant(subtitle);
  }
  return gridVariant(subtitle);
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SurfaceSubtitle);